import React from 'react';

interface DcaProgressBarProps {
  dcaDropR: number;
  dcaNextTriggerR: number | null;
  dcaHardStopR: number;
  entriesFilled: number;
}

const DcaProgressBar: React.FC<DcaProgressBarProps> = ({
  dcaDropR,
  dcaNextTriggerR,
  dcaHardStopR,
  entriesFilled,
}) => {
  const maxR = dcaHardStopR; // 1.5
  const entry2R = 0.5;
  const entry3R = 1.0;

  const entry2Pos = (entry2R / maxR) * 100;
  const entry3Pos = (entry3R / maxR) * 100;

  const clampedDrop = Math.max(0, Math.min(dcaDropR, maxR));
  const fillWidth = (clampedDrop / maxR) * 100;

  let fillColor = '#3b82f6'; // blue: safe
  if (dcaDropR >= entry3R) {
    fillColor = '#ef4444'; // red: past E3, near stop
  } else if (dcaDropR >= entry2R) {
    fillColor = '#f97316'; // orange: between E2 and E3
  } else if (dcaDropR >= entry2R * 0.6) {
    fillColor = '#f59e0b'; // yellow: approaching E2
  }

  const entry2Filled = entriesFilled >= 2;
  const entry3Filled = entriesFilled >= 3;

  return (
    <div className="dca-progress-bar">
      <div className="dca-bar-track">
        <div
          className={`dca-bar-marker ${entry2Filled ? 'marker-filled' : ''}`}
          style={{ left: `${entry2Pos}%` }}
        />
        <div
          className={`dca-bar-marker ${entry3Filled ? 'marker-filled' : ''}`}
          style={{ left: `${entry3Pos}%` }}
        />
        <div className="dca-bar-stop-marker" style={{ left: '100%' }} />
        <div
          className="dca-bar-fill"
          style={{
            width: `${fillWidth}%`,
            backgroundColor: fillColor,
          }}
        />
      </div>
      <div className="dca-bar-labels">
        <span className="dca-label-min">0</span>
        <span className="dca-label-e2" style={{ left: `${entry2Pos}%` }}>
          {entry2Filled ? 'E2 \u2713' : 'E2'}
        </span>
        <span className="dca-label-e3" style={{ left: `${entry3Pos}%` }}>
          {entry3Filled ? 'E3 \u2713' : 'E3'}
        </span>
        <span className="dca-label-max">Stop</span>
      </div>
      {dcaDropR > maxR && (
        <span className="dca-overflow" style={{ color: '#ef4444' }}>
          {dcaDropR.toFixed(2)}R
        </span>
      )}
    </div>
  );
};

export default DcaProgressBar;
